import React, { Component } from "react";
import SelectMenu from "../../components/utility/select-menu";
import rq from "../utility/rq";
import MessageBox from "../../components/utility/message-box";
import QuestionBox from "../../components/utility/question-box";
import AutoComplete from "../utility/auto-complete";
import Spinner from "../utility/spinner";
class CreateMsgEventName extends React.Component {
    constructor(props) {
        super(props);


        this.messageBox = null;
        this.questionBox = null;

    }

    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = <QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>
        this.setState(this.state);
    }
    handleSubmit() {
        var myMsg = this.refs.msg.value;
        if (myMsg) {
            this.askQuestion(`Do you watnt to create Event ${myMsg} ?`, () => {
                rq.post("/api/v1/mis/create-event-category", { eventCategoryName: myMsg }).then(() => {
                    this.refs.msg.value = "";
                    this.messageBox = MessageBox.showMessage("Event Name created successfully", true, this);
                    this.setState({});
                }).catch((err) => {
                    console.log(err);
                });
                this.questionBox = null;
                this.forceUpdate();

            }, () => {
                this.questionBox = null;
                this.forceUpdate();
            });
        } else {
            this.messageBox = MessageBox.showMessage("Enter a event name", false, this);
            this.setState({});
        }
    }
    render() {
        return (
            <div className="smallholder" >
                <p className="formMsg">Create Event Name</p>
                <table className="formTable">
                    <tbody>
                        <tr>
                            <td>
                                <p className="label">Enter Event name</p>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Enter Event name"
                                    ref="msg"

                                />
                            </td>
                        </tr >
                    </tbody >
                </table >
                <button
                    tabIndex="2"
                    className="btn btnOk btnRight"
                    onClick={this.handleSubmit.bind(this)}
                >
                    Submit
             </button>
                <div className="clear"></div>
                {this.questionBox}
                {this.messageBox}
            </div >
        );
    }
}

class ReciveCategory extends React.Component {
    constructor(props) {
        super(props);
        this.messageBox = null;
        this.questionBox = null;
    }
    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = <QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>
        this.setState(this.state);
    }
    handleSubmit() {
        var receiveCategoryName = this.refs.categoryName.value;
        var tablename = this.refs.tableName.value;
        var pkFieldName = this.refs.primaryName.value;
        var routePath = this.refs.routePath.value;
        var displayName = this.refs.displayName.value;
        if (receiveCategoryName && tablename && pkFieldName && routePath && displayName) {
            this.askQuestion(`Do you watnt to create Receive Category ?`, () => {
                rq.postJson("/api/v1/mis/create-msg-receive-category", { receiveCategoryName, tablename, pkFieldName, routePath, displayName }).then(() => {
                    this.refs.tableName.value = "";
                    this.refs.primaryName.value = "";
                    this.refs.categoryName.value = "";
                    this.refs.displayName.value = "";
                    this.refs.routePath.value = "";
                    this.messageBox = MessageBox.showMessage("Receive Category created successfully", true, this);
                    this.setState({});
                }).catch((err) => {
                    console.log(err);
                });
                this.questionBox = null;
                this.forceUpdate();

            }, () => {
                this.questionBox = null;
                this.forceUpdate();
            });
        } else {
            this.messageBox = MessageBox.showMessage(`Enter a ${!receiveCategoryName ? "Categor" : !tablename ? "Table" : !pkFieldName ? "PrimaryKey" : !displayName ? "Display" : "Route Path"} name`, false, this);
            this.setState({});
        }
    }
    render() {
        return (
            <div className="smallholder" >
                <p className="formMsg">Receive Category</p>
                <table className="formTable">
                    <tbody>
                        <tr>
                            <td>
                                <p className="label">Receive Category Name</p>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Enter Category Name"
                                    ref="categoryName"
                                />
                            </td>
                        </tr >
                        <tr>
                            <td>
                                <p className="label">Enter Table Name</p>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Enter Table Name"
                                    ref="tableName"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className="label">Primary Key  Name</p>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Primary Key  Name"
                                    ref="primaryName"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className="label">Display  Name</p>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Display  Name"
                                    ref="displayName"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className="label">Auto Complete Route Path</p>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    className="formControl inputBox"
                                    placeholder="Enter Auto Complete Route Path"
                                    ref="routePath"
                                />
                            </td>
                        </tr>
                    </tbody >
                </table >
                <button
                    tabIndex="2"
                    className="btn btnOk btnRight"
                    onClick={this.handleSubmit.bind(this)}
                >
                    Submit
         </button>
                <div className="clear"></div>
                {this.questionBox}
                {this.messageBox}
            </div >
        );
    }
}


class CreateMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ReceiveCategoryList: [],
            eventList: [],
            selectedList: [],
            showSpinner: false,
        };
        this.msgRecCategoryReset = false;
        this.eventCategoryReset = false;
        this.selectEvent = null;
        this.selectedCategory = null;
        this.messageBox = null;
        this.questionBox = null;
    }
    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = <QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>
        this.setState(this.state);
    }
    handleSubmit() {
        if (this.selectEvent && this.selectedCategory && this.state.selectedList.length > 0) {
            this.askQuestion(`Do you watnt to create Message ?`, () => {
                    this.setState({showSpinner:true})
                rq.postJson("/api/v1/mis/create-msg", { eventCategoryId: this.selectEvent.eventCategoryId, msgRecCategoryData: this.selectedCategory, selectedList: this.state.selectedList }).then(() => {
                    this.msgRecCategoryReset = true;
                    this.eventCategoryReset = true;
                    this.selectEvent = null;
                    this.selectedCategory = null;
                    this.messageBox = MessageBox.showMessage("Created Message  successfully", true, this);
                    this.setState({selectedList:[],showSpinner:false});
                }).catch((err) => {
                    console.log(err);
                });
                this.questionBox = null;
                this.forceUpdate();

            }, () => {
                this.questionBox = null;
                this.forceUpdate();
            });
        }else{
            // ${!this.selectEvent ? "Select A Receive Category" : !this.selectedCategory ? "Select A Event Category  Name" : 
            this.messageBox = MessageBox.showMessage(`${!this.selectedCategory ? "Select A Receive Category":!this.selectEvent?"Select A Event Category  Name":`Select a ${ this.selectedCategory.displayName}`}`, false, this);
            this.setState({});
        }
    }
    selectReceiveCategory = (category) => {
        if (category) {
            this.selectedCategory = category;
            this.setState({})
        }
    }
    onEventSelect = (event) => {
        if (event) {
            this.selectEvent = event;
        } else {
            this.selectEvent = null;
        }
    }
    onSelectData = (data) => {
        if (data) {
            var exist = false;
            this.state.selectedList.forEach((e) => {

                if (e[this.selectedCategory.pkFeildName] === data[this.selectedCategory.pkFeildName]) {
                    exist = true;
                    this.searchBox.value = "";
                }
            });

            if (!exist) {
                var selectedList = this.state.selectedList.concat([data]);
                this.searchBox.value = "";
                this.setState({ selectedList });
            }

        }
    }
    removeEmployee(i) {
        if (i >= 0) {
            this.state.selectedList.splice(i, 1);
            this.setState(this.state);
        }
    }
    componentWillMount() {
        rq.getJsonData(`/api/v1/mis/get-categoty-event`).then((data) => {
            this.setState({ ReceiveCategoryList: data[1], eventList: data[0] });
        }).then(() => {

        });
    }
    componentDidUpdate() {
        this.msgRecCategoryReset = false;
        this.eventCategoryReset = false;
    }
    render() {
        return (
            <div className="smallholder" >
                <p className="formMsg">Create Message</p>
                <table className="formTable">
                    <tbody>
                        <tr>
                            <td>
                                <p className="label">select a Receive Category</p>
                                <SelectMenu
                                    data={this.state.ReceiveCategoryList}
                                    onSelect={this.selectReceiveCategory}
                                    tabIndex="2"
                                    text="select a  Receive Category"

                                    ky="msgRecCategoryId"
                                    vl="msgRecCategoryName"
                                    reset={this.msgRecCategoryReset}
                                >
                                </SelectMenu>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className="label">Select Event Category  Name</p>
                                <SelectMenu
                                    data={this.state.eventList}
                                    onSelect={this.onEventSelect}
                                    tabIndex="2"
                                    text="Select Event Category  Name"
                                    ky="eventCategoryId"
                                    vl="eventCategoryName"
                                    reset={this.eventCategoryReset}
                                >
                                </SelectMenu>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className="label">Auto Complete</p>
                                <AutoComplete
                                    placeholder={`select a ${this.selectedCategory ? this.selectedCategory.displayName : "Name"}`}
                                    dataSrc={this.selectedCategory ? this.selectedCategory.routePath : "api/vi"}
                                    dataTobind={this.selectedCategory ? this.selectedCategory.displayName : "  "}
                                    keyToBind={this.selectedCategory ? this.selectedCategory.pkFeildName : "  "}
                                    tabIndex="4"
                                    onSelect={this.onSelectData.bind(this)}

                                    rex={(searchBox) => {
                                        this.searchBox = searchBox;
                                        //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);

                                    }}

                                />
                                <ul>
                                    {this.state.selectedList.map((e, i) => {
                                        return (
                                            <li key={e[this.selectedCategory.pkFeildName]} className="studentList">{e[this.selectedCategory.displayName]} <i className="fa fa-times" style={{ cursor: "pointer" }} onClick={this.removeEmployee.bind(this, i)}></i></li>
                                        );
                                    })}
                                </ul>
                            </td>
                        </tr >
                    </tbody >
                </table >
                <button
                    tabIndex="2"
                    className="btn btnOk btnRight"
                    onClick={this.handleSubmit.bind(this)}
                >
                    Submit
         </button>
                <div className="clear"></div>
                {this.questionBox}
                {this.messageBox}
                {this.state.showSpinner ? <Spinner></Spinner> : null}
            </div >
        );
    }
}

export default class MsgSubscription extends Component {
    render() {
        return (
            <div>
                <CreateMsgEventName />
                <ReciveCategory />
                <CreateMessage />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/jsx/components/fragments/msg-subscription.jsx